/**
 * Opportunities List Screen Styles
 * 
 * Consistent with v2 design system.
 * Uses design tokens exclusively per cursor rules.
 */

import { StyleSheet } from 'react-native';
import { color, text, space, radius, icon, layout, touch } from '../../../shared/tokens/mobile';

export const styles = StyleSheet.create({
  // Scroll
  scroll: {
    flex: 1,
  },
  scrollContent: {
    paddingBottom: layout.scrollBottomPadding,
  },
  
  // Section container - consistent with home screen
  section: {
    paddingHorizontal: space.md,
    marginTop: space.md,
  },
  
  // Center container for loading/error states
  centerContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: space.lg,
  },
  
  // Error state
  errorText: {
    fontSize: text.cardTitle.fontSize,
    fontWeight: text.cardTitle.fontWeight,
    color: color.textPrimary,
    marginTop: space.md,
    textAlign: 'center',
  },
  errorSubtext: {
    fontSize: text.body.fontSize,
    fontWeight: text.body.fontWeight,
    color: color.textSecondary,
    marginTop: space.xs,
    textAlign: 'center',
  },
  retryButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: touch.minimum,
    paddingVertical: space.sm,
    paddingHorizontal: space.lg,
    gap: space.xs,
    backgroundColor: color.primary,
    borderRadius: radius.md,
    marginTop: space.lg,
  },
  retryButtonText: {
    fontSize: text.body.fontSize,
    fontWeight: text.bodyMedium.fontWeight,
    color: color.surface,
  },
  
  // Empty state
  emptyState: {
    paddingVertical: space.xxl,
    paddingHorizontal: space.lg,
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyTitle: {
    fontSize: text.cardTitle.fontSize,
    fontWeight: text.cardTitle.fontWeight,
    color: color.textPrimary,
    marginTop: space.md,
    textAlign: 'center',
  },
  emptySubtitle: {
    fontSize: text.body.fontSize,
    fontWeight: text.body.fontWeight,
    color: color.textSecondary,
    marginTop: space.xs,
    textAlign: 'center',
  },
  emptyAddButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: touch.minimum,
    paddingVertical: space.sm,
    paddingHorizontal: space.lg,
    gap: space.xs,
    backgroundColor: color.primary,
    borderRadius: radius.md,
    marginTop: space.lg,
  },
  emptyAddButtonText: {
    fontSize: text.body.fontSize,
    fontWeight: text.bodyMedium.fontWeight,
    color: color.surface,
  },
  
  // Add opportunity button
  addButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: touch.listRow,
    paddingVertical: space.md,
    gap: space.sm,
    backgroundColor: color.surface,
    borderRadius: radius.lg,
    borderWidth: 1,
    borderColor: color.border,
    borderStyle: 'dashed',
  },
  addButtonPressed: {
    backgroundColor: color.primaryLight,
    borderColor: color.primary,
    borderStyle: 'solid',
  },
  addButtonText: {
    fontSize: text.body.fontSize,
    fontWeight: text.bodyMedium.fontWeight,
    color: color.primary,
  },
});
